export enum PosType {
  LEGACY_POS = '1',
}
